// extracted by mini-css-extract-plugin
export default {"rectangle":"SN0I1Sb","full":"E8zXhwR"};